import React, { useState } from 'react';
import { makeStyles } from 'utils/makeStylesAdapter';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Tooltip, TextField } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import { Autocomplete } from '@mui/material';
import { setGroupReducer, setSelectedIndexGroup } from '../../../../../../actions';
import { ModalChangeGroup } from './components';
import { colors } from 'utils/colorsSteps';
import { useParameterKeys } from 'hooks/useParameterKeys';

const useStyles = makeStyles(() => ({
  grupoOficioStyle: {
    fontFamily: 'Roboto-Regular',
    color: ({ isLightTheme }) => isLightTheme ? '#000000' : '#ffffff',
    textTransform: 'capitalize',
    fontSize: 12,
    fontWeight: 'normal',
  },
  autocompleteStyle: {
    width: 350,
    backgroundColor: '#fff',
    borderRadius: 6,
  },
  inputRoot: {
    padding: '2px 4px !important',
    backgroundColor: ({ isLightTheme }) => isLightTheme ? '#d1e7f1' : colors.primary,
    border: 'none',
    cursor: 'pointer',
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
  },
  input: {
    backgroundColor: ({ isLightTheme }) => isLightTheme ? '#d1e7f1' : colors.primary,
    color: ({ isLightTheme }) => isLightTheme ? '#000000' : '#fff',
    padding: '3px !important',
    border: 'none',
    cursor: 'pointer',
    fontSize: '12px',
    lineHeight: '1.4',
    maxHeight: '44px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    '&::placeholder': {
      color: ({ isLightTheme }) => isLightTheme ? '#000000' : '#fff',
      opacity: 1,
    },
  },
  listbox: {
    maxWidth: '500px',
    '& .MuiAutocomplete-option': {
      overflow: 'visible',
      whiteSpace: 'normal',
      wordWrap: 'break-word',
      padding: '8px !important',
    },
  },
  endAdornment: {
    display: 'flex',
    alignItems: 'center',
    color: ({ isLightTheme }) => isLightTheme ? '#000000' : 'white',
  },
}));

export default function GroupsMenu() {
  const { applyLightTheme } = useParameterKeys();
  const classes = useStyles({ isLightTheme: applyLightTheme });
  const dispatch = useDispatch();
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [openChangeGroup, setOpenChangeGroup] = useState(false);

  const groups = useSelector(state => state.logedUser.groups);
  const { selectedIndexGroup } = useSelector(state => state.groupMenu);

  const handleGroupChange = (event, newValue) => {
    if (newValue && newValue.id !== groups[selectedIndexGroup]?.id) {
      setSelectedGroup(newValue);
      setOpenChangeGroup(true);
    }
  };

  const confirmChange = () => {
    const index = groups.findIndex(group => group.id === selectedGroup.id);
    dispatch(setGroupReducer(selectedGroup));
    dispatch(setSelectedIndexGroup(index));
    setSelectedGroup(null);
    setOpenChangeGroup(false);
  };

  return (
    <div>
      <Box style={{ marginRight: 10 }}>
        <Tooltip arrow title="Grupo ofício">
          <Autocomplete
            options={groups}
            getOptionLabel={option => option?.name || ''}
            className={classes.autocompleteStyle}
            classes={{
              inputRoot: classes.inputRoot,
              input: classes.input,
              listbox: classes.listbox,
            }}
            ListboxProps={{
              style: { maxHeight: '400px' }
            }}
            disableClearable
            openOnFocus
            blurOnSelect
            renderInput={params => (
              <TextField
                {...params}
                placeholder="Grupo Ofício"
                variant="outlined"
                multiline
                maxRows={2}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <div className={classes.endAdornment}>
                      <GroupIcon style={{ marginRight: 5, marginLeft: 5 }} color="white" />
                      {params.InputProps.endAdornment}
                    </div>
                  ),
                }}
              />
            )}
            value={groups[selectedIndexGroup] || null}
            onChange={handleGroupChange}
          />
        </Tooltip>
      </Box>
      {openChangeGroup && (
        <ModalChangeGroup
          open={openChangeGroup}
          onClose={() => setOpenChangeGroup(false)}
          group={selectedGroup}
          confirmChange={confirmChange}
        />
      )}
    </div>
  );
}
